export default __webpack_public_path__ + "static/media/close_x.91a386db.svg";